// src/pages/AdminActes.jsx
import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { CONFIG } from "../config/config";

export default function AdminActes() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [savingId, setSavingId] = useState(null);
  const token = sessionStorage.getItem("token") || localStorage.getItem("token");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const r = await fetch(`${CONFIG.API_URL}/actes`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const j = r.ok ? await r.json() : [];
        setRows(Array.isArray(j) ? j : j?.data || []);
      } catch {
        setRows([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [token]);

  const updateCell = (id, field, value) => {
    setRows((prev) => prev.map((x) => (x.id === id ? { ...x, [field]: value } : x)));
  };

  const saveRow = async (id) => {
    const row = rows.find((x) => x.id === id);
    if (!row) return;
    setSavingId(id);
    try {
      const r = await fetch(`${CONFIG.API_URL}/actes/${id}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(row),
      });
      if (!r.ok) throw new Error("save error");
    } catch {
      alert("Impossible d’enregistrer cet acte.");
    } finally {
      setSavingId(null);
    }
  };

  const addRow = async () => {
    const payload = {
      code: "",
      category: "",
      shortLabel: "",
      libelle: "",
      cpam: 0,
    };
    try {
      const r = await fetch(`${CONFIG.API_URL}/actes`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(payload),
      });
      if (!r.ok) throw new Error("create error");
      const created = await r.json();
      setRows((prev) => [created, ...prev]);
    } catch {
      alert("Création impossible.");
    }
  };

  return (
    <PageLayout title="Administration - Actes">
      <div className="p-4">
        <div className="mb-3 flex justify-between items-center">
          <h2 className="text-lg font-semibold">Catalogue d’actes</h2>
          <button
            type="button"
            onClick={addRow}
            className="px-3 py-2 rounded bg-gray-900 text-white hover:bg-black"
          >
            Nouvel acte
          </button>
        </div>

        <div className="overflow-x-auto border rounded">
          <table className="min-w-[720px] w-full text-sm">
            <thead className="bg-gray-50">
              <tr>
                <th className="text-left p-2 border-r">Code</th>
                <th className="text-left p-2 border-r">Catégorie</th>
                <th className="text-left p-2 border-r">Libellé court</th>
                <th className="text-left p-2 border-r">Libellé</th>
                <th className="text-right p-2 border-r">CPAM</th>
                <th className="text-right p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={6} className="p-3 text-center text-gray-500">Chargement…</td></tr>
              ) : rows.length === 0 ? (
                <tr><td colSpan={6} className="p-3 text-center text-gray-500">Aucun acte</td></tr>
              ) : (
                rows.map((r) => (
                  <tr key={r.id} className="border-t">
                    <td className="p-2 border-r">
                      <input className="w-full border rounded px-2 py-1" value={r.code || ""} onChange={(e) => updateCell(r.id, "code", e.target.value)} />
                    </td>
                    <td className="p-2 border-r">
                      <input className="w-full border rounded px-2 py-1" value={r.category || ""} onChange={(e) => updateCell(r.id, "category", e.target.value)} />
                    </td>
                    <td className="p-2 border-r">
                      <input className="w-full border rounded px-2 py-1" value={r.shortLabel || ""} onChange={(e) => updateCell(r.id, "shortLabel", e.target.value)} />
                    </td>
                    <td className="p-2 border-r">
                      <input className="w-full border rounded px-2 py-1" value={r.libelle || ""} onChange={(e) => updateCell(r.id, "libelle", e.target.value)} />
                    </td>
                    <td className="p-2 border-r text-right">
                      <input className="w-full border rounded px-2 py-1 text-right" type="number" step="0.01" value={r.cpam ?? 0} onChange={(e) => updateCell(r.id, "cpam", parseFloat(e.target.value || "0"))} />
                    </td>
                    <td className="p-2 text-right">
                      <button
                        onClick={() => saveRow(r.id)}
                        disabled={savingId === r.id}
                        className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50"
                      >
                        {savingId === r.id ? "…" : "Enregistrer"}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </PageLayout>
  );
}
